module.exports = __webpack_public_path__ + "5d0ad54b9ad96b38a30c2389a8e2f6b0.svg";